import styled from 'styled-components';
import { BasketSelectSectionStyled } from '../BasketSeclectSectionStyled';
import { rem } from 'polished';

export const BasketSeclectSectionAP = styled(BasketSelectSectionStyled)``;
